// extracted by mini-css-extract-plugin
module.exports = {"toolIcon":"ToolBox_toolIcon__1xGSn","toolButton":"ToolBox_toolButton__1g_hB","outputText":"ToolBox_outputText__1eAX-","promptText":"ToolBox_promptText__4JNNK"};